import Card from "@material-ui/core/Card";
import { makeStyles } from "@material-ui/core/styles";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import CardTitle from "@saleor/components/CardTitle";
import ResponsiveTable from "@saleor/components/ResponsiveTable";
import Skeleton from "@saleor/components/Skeleton";
import TableCellAvatar from "@saleor/components/TableCellAvatar";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { maybe, renderCollection } from "../../../misc";
import { CustomerDetails_user_productActivations_edges_node } from "../../types/CustomerDetails";

const useStyles = makeStyles(
  {
    link: {
      cursor: "pointer"
    },
    textRight: {
      textAlign: "right"
    }
  },
  { name: "CustomerProductActivations" }
);

export interface CustomerProductActivationsProps {
  activations: CustomerDetails_user_productActivations_edges_node[];
}

const CustomerProductActivations: React.FC<CustomerProductActivationsProps> = props => {
  const { activations } = props;
  const classes = useStyles(props);

  const intl = useIntl();

  const activationList = activations
    ? activations.map(activation => ({
        ...activation
      }))
    : undefined;
  return (
    <Card>
      <CardTitle
        title={intl.formatMessage({
          defaultMessage: "Recent Product Activations",
          description: "section header"
        })}
      />
      <ResponsiveTable>
        <TableHead>
          <TableRow>
            <TableCell>
              <FormattedMessage
                defaultMessage="Product Image"
                description="Product Image"
              />
            </TableCell>
            <TableCell>
              <FormattedMessage defaultMessage="Sku" description="Sku" />
            </TableCell>
            <TableCell>
              <FormattedMessage
                defaultMessage="Serial Number"
                description="Serial Number"
              />
            </TableCell>
            <TableCell>
              <FormattedMessage
                defaultMessage="Order No"
                description="Order No"
              />
            </TableCell>
            <TableCell>
              <FormattedMessage
                defaultMessage="Warranty Date"
                description="Warranty Date"
              />
            </TableCell>
            <TableCell className={classes.textRight}>
              <FormattedMessage
                defaultMessage="User Images"
                description="User Images"
              />
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {renderCollection(
            activationList,
            activation => (
              <TableRow
                hover={!!activation}
                className={!!activation ? classes.link : undefined}
                key={activation ? activation.id : "skeleton"}
              >
                <TableCellAvatar
                  thumbnail={maybe(() => activation.productImageUrl)}
                ></TableCellAvatar>
                <TableCell>
                  {maybe(() => activation.sku) ? activation.sku : <Skeleton />}
                </TableCell>
                <TableCell>
                  {maybe(() => activation.serialNumber) ? (
                    activation.serialNumber
                  ) : (
                    <Skeleton />
                  )}
                </TableCell>
                <TableCell>
                  {maybe(() => activation.orderId) ? (
                    activation.orderId
                  ) : (
                    <Skeleton />
                  )}
                </TableCell>
                <TableCell>
                  {maybe(() => activation.warrantyStartDate) ? (
                    activation.warrantyStartDate +
                    " " +
                    activation.warrantyEndDate
                  ) : (
                    <Skeleton />
                  )}
                </TableCell>
                <TableCell>
                  {maybe(() => activation.userImages) ? (
                    activation.userImages.map(userimage => (
                      <TableCellAvatar
                        thumbnail={maybe(() => userimage.imageUrl)}
                        style={{ border: 0, padding: 5 }}
                      ></TableCellAvatar>
                    ))
                  ) : (
                    <Skeleton />
                  )}
                </TableCell>
              </TableRow>
            ),
            () => (
              <TableRow>
                <TableCell colSpan={6}>
                  <FormattedMessage defaultMessage="No Product Activations found" />
                </TableCell>
              </TableRow>
            )
          )}
        </TableBody>
      </ResponsiveTable>
    </Card>
  );
};

CustomerProductActivations.displayName = "CustomerProductActivations";
export default CustomerProductActivations;
